import React from 'react'
import { Link } from 'gatsby'

const NavigationTwoSlidesRight = () => (
  // console.log('Right')

  <div>
    {/* <h1 onClick={toggleNavOpen}>Right</h1> */}
    <div className="container-right-checkout-menu">
      <div className="right-menu-item right-item-1">
        <Link to="/microshading-brows/" className="w3-btn w3-white">
          Microshading Brows
        </Link>
      </div>
      <div className="right-menu-item right-item-2">
        <Link to="/ombre-brows/" className="w3-btn w3-white">
          Ombre Brows
        </Link>
      </div>
      <div className="right-menu-item right-item-3">
        <Link to="/powder-brows/" className="w3-btn w3-white">
          Powder Brows
        </Link>
      </div>
      <div className="right-menu-item right-item-4">
        <Link to="/lip-blush/" className="w3-btn w3-white">
          Lip Blush
        </Link>
      </div>
      <div className="right-menu-item right-item-5">
        <Link to="/lash-line-enhancement/" className="w3-btn w3-white">
          Lash Line Enhancement
        </Link>
      </div>
      <div className="right-menu-item right-item-6">
        <Link to="/li-ft-removal/" className="w3-btn w3-white">
          Li-FT Removal
        </Link>
      </div>
    </div>
  </div>
)

export default NavigationTwoSlidesRight
